import reframe from 'nike-re-framejs';
import PopupNg from '@/ui/PopupNg';
import { defaultMiddlewares } from '@/common/util';

reframe.regEventDb('ui.showSection', defaultMiddlewares, (db, [section]) =>
    db.setIn(['gui', 'sectionExpanded', section], true)
);

reframe.regEventDb('ui.hideSection', defaultMiddlewares, (db, [section]) =>
    db.setIn(['gui', 'sectionExpanded', section], false)
);

reframe.regEventDb('ui.toggleSection', defaultMiddlewares, (db, [section]) =>
    db.updateIn(['gui', 'sectionExpanded', section], value => !value)
);

reframe.regEventDb('ui.showPopup', defaultMiddlewares, (db, [data]) => db.update(PopupNg.updater.show(data)));

reframe.regEventDb('ui.showMasterError', defaultMiddlewares, (db, [messages, title, onClose, htmlMessages]) => {
    return db.update(
        PopupNg.updater.show(
            {
                style: 'error',
                messages: messages,
                title: title,
                close: onClose ? onClose : [],
                htmlMessages: htmlMessages
            },
            1000
        )
    );
});

reframe.regEventDb('ui.reload', defaultMiddlewares, db => {
    window.location.reload();
    return db;
});

reframe.regEventDb('ui.reloadHome', defaultMiddlewares, db => {
    window.location.href = '/';
    return db;
});

reframe.regEventDb('ui.setHeaderTitle', defaultMiddlewares, (db, [title]) => db.update(setHeaderTitle(title)));

reframe.regEventDb('ui.popup/ng', defaultMiddlewares, (db, [name, data, priority]) => {
    if (name) {
        return db.update(PopupNg.updater.open(name, data, priority));
    }
    return db.update(PopupNg.updater.close());
});

reframe.regEventDb('ui.popup/ng-close', defaultMiddlewares, (db, [name]) => {
    return db.update(PopupNg.updater.close(name));
});

reframe.regEventDb('ui.popup/ng-close-all', defaultMiddlewares, db => {
    return db.update(PopupNg.updater.closeAll());
});

export const setHeaderTitle = function(title) {
    return function(db) {
        const docTitle = buildTitle(title);
        document.title = docTitle ? `Niké | ${docTitle}` : 'Niké';
        return db.set('headerTitle', title);
    };
};

export function buildTitle(title) {
    if (title) {
        if (title.size > 0) {
            return title.get(0) + (title.get(1) ? ' - ' + title.get(1) : '');
        }
        return title;
    }
    return '';
}

reframe.regEventDb('informationDuty.setLoaded', defaultMiddlewares, db =>
    db.setIn(['account', 'informationDutyLoaded'], true)
);
